export default {
  url: 'https://get.geojs.io/v1/ip/geo.json'
}